/* global window */

import log from 'loglevel';

class MediaOS {
  static updateWeather(location) {
    if (location && window.Dewy && window.Dewy.updateUserLocation) {
      const { lat, lon } = location[0];
      window.Dewy.updateUserLocation(lat, lon);
      log.debug('MediaOS: updating user location for weather.');
    }

    return Promise.resolve();
  }
}

export default MediaOS;



// WEBPACK FOOTER //
// ./src/MediaOS.js